import React, { useState } from "react";
import styled from "styled-components";
import { Container } from "../style";
import { Link } from "react-router-dom";

const PageWrapper = styled.div`

  min-height: 100vh;
  padding: 40px 0 60px;
`;

const BackLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #2c5282;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 30px;
  letter-spacing: 0.3px;
  transition: color 0.2s;
  &:hover { color: #1a365d; }
`;

const Hero = styled.div`
  background: #2c5282;
  border-radius: 12px;
  padding: 40px 48px;
  margin-bottom: 32px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  @media (max-width: 768px) {
    flex-direction: column;
    padding: 28px 24px;
  }
`;

const HeroLeft = styled.div``;

const DocBadge = styled.div`
  display: inline-block;
  background: rgba(255,255,255,0.15);
  color: rgba(255,255,255,0.85);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  padding: 5px 12px;
  border-radius: 4px;
  margin-bottom: 16px;
`;

const HeroTitle = styled.h1`
  color: #fff;
  font-size: 26px;
  font-weight: 700;
  line-height: 1.35;
  margin: 0 0 8px;
  max-width: 600px;
`;

const HeroMeta = styled.p`
  color: rgba(255,255,255,0.65);
  font-size: 13px;
  margin: 0;
`;

const DownloadBtn = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  color: #2c5282;
  font-size: 13px;
  font-weight: 700;
  padding: 12px 20px;
  border-radius: 8px;
  text-decoration: none;
  white-space: nowrap;
  transition: background 0.2s, transform 0.15s;
  flex-shrink: 0;
  &:hover { background: #ebf4ff; transform: translateY(-1px); }
`;

const Card = styled.div`
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.07);
  margin-bottom: 20px;
  overflow: hidden;
`;

const SectionHeader = styled.button`
  width: 100%;
  background: none;
  border: none;
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  text-align: left;
  border-bottom: ${p => p.open ? "2px solid #e8eef7" : "none"};
  transition: background 0.15s;
  &:hover { background: #f7f8fa; }
`;

const SectionNum = styled.span`
  background: #2c5282;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  flex-shrink: 0;
`;

const SectionTitle = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: #1a365d;
  flex: 1;
`;

const Arrow = styled.span`
  color: #718096;
  font-size: 18px;
  transition: transform 0.2s;
  transform: ${p => p.open ? "rotate(90deg)" : "rotate(0deg)"};
  margin-left: 12px;
`;

const SectionBody = styled.div`
  padding: ${p => p.open ? "24px 28px" : "0"};
  max-height: ${p => p.open ? "9999px" : "0"};
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.2s;
`;

const Clause = styled.div`
  margin-bottom: 14px;
  font-size: 14px;
  color: #2d3748;
  line-height: 1.75;
  padding-left: 16px;
  border-left: 2px solid #e2e8f0;
`;

const ClauseNum = styled.span`
  font-weight: 700;
  color: #2c5282;
  margin-right: 6px;
`;

const AwardCard = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 14px 16px;
  border-radius: 8px;
  background: #f7f9fc;
  margin-bottom: 10px;
  border: 1px solid #e8eef7;
`;

const AwardIcon = styled.div`
  font-size: 22px;
  flex-shrink: 0;
  margin-top: 1px;
`;

const AwardText = styled.div`
  font-size: 14px;
  color: #2d3748;
  line-height: 1.6;
`;

const DefTerm = styled.div`
  margin-bottom: 10px;
  padding: 12px 14px;
  background: #f7f9fc;
  border-radius: 7px;
  border-left: 3px solid #2c5282;
`;

const DefWord = styled.span`
  font-weight: 700;
  color: #2c5282;
  display: block;
  font-size: 13px;
  margin-bottom: 3px;
`;

const DefDesc = styled.span`
  font-size: 13px;
  color: #4a5568;
  line-height: 1.6;
`;

// ─── Data ───────────────────────────────────────────────────────────────────

const awards = [
  { icon: "🥇", name: "Нишони тиллоии АБТ", desc: "Олитарин ҷоизаи Ассотсиатсия. Ҳар сол ба як нафар дода мешавад." },
  { icon: "🥈", name: "Нишони нуқраи АБТ", desc: "Дуввумин ҷоизаи бонуфузи Ассотсиатсия." },
  { icon: "🏅", name: "Нишони фахрии АБТ", desc: "Ба хизматҳои назарраси фардӣ дода мешавад." },
  { icon: "📜", name: "Дипломи фахрии АБТ", desc: "Диплом ҳамзамон бо нишонҳо таъин мешавад." },
  { icon: "🤝", name: "Ҷоизаи «Барои ҳамкорӣ»", desc: "Барои хизматрасонии муштарак ва шарикӣ." },
  { icon: "🏆", name: "Номинатсия", desc: "Аз рӯи мавзӯи тасдиқкардашуда." },
  { icon: "📋", name: "Ифтихорнома", desc: "Барои фаъолият ва хизматрасонии солона." },
  { icon: "🎖️", name: "Ҷоизаҳои идоравӣ", desc: "Барои кормандони ташкилотҳои қарзию молиявӣ." },
  { icon: "💰", name: "Мукофоти пулӣ", desc: "Мукофотонидан бо маблағи пулӣ." },
];

const definitions = [
  { word: "Рӯйдоди муҳим", desc: "Рӯйдоди дорои аҳамияти мусбати назарраси иҷтимоӣ ва таъсири баланди молиявӣ дар соҳаи бонкӣ." },
  { word: "Солгард", desc: "Рӯзи оғози рӯйдодҳои муҳими таърихӣ, давлатӣ ва ҷамъиятӣ." },
  { word: "Санаи хотирмон", desc: "Санаи алоқаманд бо рӯйдодҳои муайяни таърихӣ дар ҳаёти гирандаи ҷоиза." },
  { word: "Ҷашнвора", desc: "00-солагӣ ва баъдан ҳар 00 сол аз санаи таъсис, инчунин 50-солагии корманд." },
  { word: "Ҷоиза", desc: "Шакли эътироф ва қадрдонии хизматҳои махсуси кормандон ва гирандаи ҷоиза дар назди Ассотсиатсия." },
  { word: "Ҳавасмандгардонӣ", desc: "Маҷмӯи чорабиниҳо, усулҳо ва воситаҳое, ки барои бедор кардани шавқ ва ангезаи шахс ё гурӯҳ истифода мешаванд." },
];

const docs = [
  "а) Пешниҳод аз ташкилотҳои қарзию молиявӣ",
  "б) Арзёбии натиҷаҳои касбӣ ва маълумот дар бораи таҷрибаи корӣ",
  "в) Протоколи ҷаласа ё қарорҳои мақомоти коллегиалӣ",
  "г) Ҳадди аққал ду тавсиянома аз роҳбарон ё мутахассисони соҳа",
  "д) Нусхаҳои шиноснома ва дафтарчаи меҳнатӣ",
  "е) Маълумотнома оид ба набудани муҷозоти интизомии фаъол",
  "ж) Маълумот дар бораи ҷоизаҳои ду соли охир",
];

const sections = [
  {
    num: "1",
    title: "Муқаррароти умумӣ",
    content: (
      <>
        <Clause><ClauseNum>1.1.</ClauseNum>Низомномаи мазкур бо мақсади муайян кардани тартиб ва шартҳои мукофотонидан ва ҳавасмандгардонии кормандони АБТ, кормандони БМТ, ташкилотҳои қарзию молиявӣ, намояндагони мақомоти давлатӣ ва ғайридавлатӣ таҳия ва тасдиқ карда шудааст (Протокол №22 аз 23 декабри 2025).</Clause>
        <Clause><ClauseNum>1.2.</ClauseNum>Истилоҳот ва маҳфумҳои асосӣ:</Clause>
        {definitions.map((d, i) => (
          <DefTerm key={i}>
            <DefWord>{d.word}</DefWord>
            <DefDesc>{d.desc}</DefDesc>
          </DefTerm>
        ))}
        <Clause style={{marginTop:14}}><ClauseNum>1.3.</ClauseNum>Гирандагони ҷоизаҳо — субъектҳои ҳуқуқӣ, ташкилотҳои молиявӣ, мақомоти маҳаллӣ ва шаҳрвандони Ҷумҳурии Тоҷикистон ва хориҷа, ки саҳми назаррас дар рушди соҳаи бонкӣ гузоштаанд.</Clause>
        <Clause><ClauseNum>1.4.</ClauseNum>Ҷоиза (ҳавасмандгардонӣ) ба гиранда дар вазъияти тантанавӣ супорида мешавад.</Clause>
        <Clause><ClauseNum>1.5.</ClauseNum>Агар гиранда бинобар беморӣ ё маъюбӣ иштирок карда натавонад, ҷоиза дар манзили истиқоматияш супорида мешавад.</Clause>
        <Clause><ClauseNum>1.7.</ClauseNum>Ҳуқуқи пешниҳоди ҷоизаҳо ба роҳбарият ва коллективҳои меҳнатии ташкилотҳо, мақомоти маҳаллӣ ва роҳбарони ташкилотҳои қарзию молиявӣ дода мешавад.</Clause>
      </>
    ),
  },
  {
    num: "2",
    title: "Намудҳои ҷоизаҳо ва ҳавасмандгардонӣ",
    content: (
      <>
        <Clause style={{marginBottom:16}}><ClauseNum>2.1.</ClauseNum>Ассотсиатсияи бонкҳои Тоҷикистон метавонад ҷоизаҳои зеринро таъсис диҳад:</Clause>
        {awards.map((a, i) => (
          <AwardCard key={i}>
            <AwardIcon>{a.icon}</AwardIcon>
            <AwardText><strong>{a.name}.</strong> {a.desc}</AwardText>
          </AwardCard>
        ))}
        <Clause style={{marginTop:14}}><ClauseNum>2.2.</ClauseNum>Тавсиф, намуна ва расмҳои ҷоизаҳо аз тарафи комиссия омода карда ба Низомнома замима карда мешаванд.</Clause>
      </>
    ),
  },
  {
    num: "3",
    title: "Талабот барои мукофотонидан ва ҳавасмандгардонӣ",
    content: (
      <>
        <Clause><ClauseNum>3.1.</ClauseNum>Номгӯи ҳуҷҷатҳои зарурӣ:</Clause>
        {docs.map((d, i) => (
          <AwardCard key={i} style={{background:"#fafbff"}}>
            <AwardIcon style={{fontSize:16}}>📎</AwardIcon>
            <AwardText>{d}</AwardText>
          </AwardCard>
        ))}
        <Clause style={{marginTop:14}}><ClauseNum>3.2.</ClauseNum>Ба таври истисно, барои дастовардҳои баланд, бо қарори Шӯро, ҷоиза метавонад бидуни риояи меъёрҳои муайяншуда дода шавад.</Clause>
        <Clause><ClauseNum>3.4.</ClauseNum>Маводҳо дар ҳолатҳои зерин бидуни баррасӣ баргардонида мешаванд: риоя накардани мӯҳлатҳо, пешниҳоди нопурраи ҳуҷҷатҳо, ё ҷавобгӯ набудани номзадҳо ба талаботи молиявӣ.</Clause>
        <Clause><ClauseNum>3.5.</ClauseNum>Пас аз рад кардани пешниҳод, такроран пешниҳоди номзад на пештар аз як сол қабул карда мешавад.</Clause>
      </>
    ),
  },
  {
    num: "4",
    title: "Намудҳои ҷоизаҳо, тартиб ва шарти мукофотонидан",
    content: (
      <>
        <Clause><ClauseNum>4.1.1.</ClauseNum><strong>Нишони тиллоӣ</strong> — ҷоизаи олии Ассотсиатсия. Ҳар сол ба як нафар дода мешавад. Як шахс наметавонад ду маротиба онро гирад. Дипломи тиллоӣ ҳамзамон дода мешавад.</Clause>
        <Clause><ClauseNum>4.2.1.</ClauseNum><strong>Нишони нуқра</strong> — дуввумин ҷоизаи бонуфузи Ассотсиатсия. Барои хизматҳо дар рушди Ассотсиатсия ва низоми бонкӣ ва дар робита ба чорабиниҳои солгард дода мешавад.</Clause>
      </>
    ),
  },
];

// ─── Component ───────────────────────────────────────────────────────────────

function AwardsRegulation() {
  const [open, setOpen] = useState({ 0: true });

  const toggle = (i) => setOpen(prev => ({ ...prev, [i]: !prev[i] }));

  return (
    <PageWrapper>
      <Container>
        <BackLink to="/">← Бозгашт ба саҳифаи асосӣ</BackLink>

        <Hero>
          <HeroLeft>
            <DocBadge>Протокол №22 · 23 декабри 2025</DocBadge>
            <HeroTitle>Низомнома дар бораи ҷоизаҳо ва ҳавасмандгардонии Ассотсиатсияи бонкҳои Тоҷикистон</HeroTitle>
            <HeroMeta>Тасдиқшуда аз ҷониби Маҷлиси умумии АБТ</HeroMeta>
          </HeroLeft>
          <DownloadBtn
            href="https://abt.tj/files/nizomnomai-mukofot.docx"
            download
          >
            ⬇ Зеркашӣ (.docx)
          </DownloadBtn>
        </Hero>

        {sections.map((sec, i) => (
          <Card key={i}>
            <SectionHeader open={open[i]} onClick={() => toggle(i)}>
              <SectionNum>{sec.num}</SectionNum>
              <SectionTitle>{sec.title}</SectionTitle>
              <Arrow open={open[i]}>›</Arrow>
            </SectionHeader>
            <SectionBody open={open[i]}>
              {sec.content}
            </SectionBody>
          </Card>
        ))}
      </Container>
    </PageWrapper>
  );
}

export default AwardsRegulation;